(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/set-global/set-global.js') >= 0) return;  svs.modules.push('/components/utils/set-global/set-global.js'); "use strict";

(function () {
  var isObject = function isObject(val) {
    return "".concat(val) === '[object Object]';
  };

  function setGlobal(path, value) {
    var parts = path.split('.');
    var pathSegments = [];
    var currentPath = window;

    while (parts.length > 1) {
      var _step = parts.shift();

      pathSegments.push(_step);

      if (currentPath[_step] !== undefined && !isObject(currentPath[_step])) {
        throw new Error("Failed trying to set property `".concat(_step, "` to non-object value in path`").concat(pathSegments.join('.'), "`"));
      }

      currentPath[_step] = currentPath[_step] || {};
      currentPath = currentPath[_step];
    }

    var step = parts[0];
    pathSegments.push(step);

    if (currentPath[step] === undefined) {
      currentPath[step] = value;
    } else if (!isObject(currentPath[step])) {
      throw new Error("Failed trying to set value on non-object in `".concat(pathSegments.join('.'), "`"));
    } else if (isObject(value)) {
      for (var key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          if (currentPath[step][key] !== undefined) {
            throw new Error("Failed trying to set value on existing property `".concat(key, "` in `").concat(pathSegments.join('.'), "`"));
          }

          currentPath[step][key] = value[key];
        }
      }
    } else {
      throw new Error("Failed trying to set non-object value on object in path `".concat(pathSegments.join('.'), "`"));
    }

    return currentPath[step];
  }

  if (!window.setGlobal) {
    Object.defineProperty(window, 'setGlobal', {
      value: setGlobal,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
})();
 })(window);